<template>
  <div class="mt-22 fixed z-10  inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
        >&#8203;</span
      >

      <div
        class="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl sm:w-1/2 mt-32 sm:mt-auto transform transition-all align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <contact
          source="home"
          :buyer="false"
          v-on:close="closeModal()"
          v-on:event="redirectListing()"
        ></contact>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    redirectListing() {
      this.$emit("closeModal");
      this.$router.push({ name: "listings" });
    },

    closeModal() {
      this.$emit("closeModal");
    }
  }
};
</script>
